var _rect, _path, _line, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeldInReserveAmountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    width: 22,
    height: 14,
    rx: 1.5,
    stroke: "#3876BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.7356L20.0786 10L17.0862 13.3439L15.8286 12.2191L15 13.0462L17.1837 15L21 10.7356Z",
    fill: "#3876BB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 7.5,
    x2: 23,
    y2: 7.5,
    stroke: "#3876BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5V1",
    stroke: "#3876BB",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5V1",
    stroke: "#3876BB",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5V1",
    stroke: "#3876BB",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeldInReserveAmountIcon);
export default __webpack_public_path__ + "static/media/HeldInReserveAmountIcon.7540b5b6d25d0b2fc4b52c10da3a8630.svg";
export { ForwardRef as ReactComponent };